/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Shop_Order_Limit_ReachedInputs */

const vi_error_shop_order_limit_reached = /** @type {(inputs: Error_Shop_Order_Limit_ReachedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bạn đang có nhiều đơn chờ xác nhận, vui lòng đợi nhân viên gọi.`)
};

/**

* @param {Error_Shop_Order_Limit_ReachedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_shop_order_limit_reached = /** @type {((inputs?: Error_Shop_Order_Limit_ReachedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Shop_Order_Limit_ReachedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_shop_order_limit_reached(inputs)
});